import http from '@/services/http';
import { error } from '@/utils/safetyLog';
import axios from 'axios';

const APP_BASE_URL = process.env.NEXT_PUBLIC_APP_BASE_URL;

export const getDefaultPromotion = async (productId?: string) => {
  try {
    const response = await axios.get(`${APP_BASE_URL}/quote/defaultPromotion/${productId}`);
    return response;
  } catch (e) {
    error(
      'get default promotion error:',
      { httpEndpoint: `${APP_BASE_URL}/quote/defaultPromotion/${productId}`, payload: {} },
      e,
    );
    return null;
  }
};

export const getQuoteData = async (requestData: any, config?: any) => {
  const endpoint = '/quote/detail';
  try {
    const response = await http({}).post(endpoint, { ...requestData }, { ...config });
    return response;
  } catch (e) {
    error(
      'get quote data error:',
      { httpEndpoint: http({}).defaults.baseURL + endpoint, requestData: requestData, config: config },
      e,
    );
    return null;
  }
};

export const getPromotionDetail = async (requestData: any) => {
  const endpoint = '/quote/promotion';
  const payload = { ...requestData };
  try {
    const response = await http({}).post(endpoint, payload);
    return response;
  } catch (e) {
    error('get promotion detail error:', { httpEndpoint: http({}).defaults.baseURL + endpoint, payload: payload }, e);
    return null;
  }
};
